document.addEventListener('DOMContentLoaded', function() {
    const el = document.body;
    window.addEventListener('scroll', function (e) {
        if (!el.classList.contains('scrolled') && window.scrollY > 0) {
            el.classList.add('scrolled');
        } else if (window.scrollY === 0) {
            el.classList.remove('scrolled');
        }
    });
    if (!el.classList.contains('scrolled') && window.scrollY > 0) {
        el.classList.add('scrolled');
    } else if (window.scrollY === 0) {
        el.classList.remove('scrolled');
    }
});

(function($) {
    const navbarContent = $('#navbar-content');
    if (navbarContent) {
        const htmlBody = $('html body');
        navbarContent.on('hide.bs.collapse', function () {
            htmlBody.removeClass('navbar-shown');
            navbarContent.addClass('hide');
        });
        navbarContent.on('show.bs.collapse', function () {
            htmlBody.addClass('navbar-shown');
            navbarContent.removeClass('hide');
        });

    }

    const body = $('body');
    let dropdown;
    function calculateAndPositionDropdownMenu() {
        if (dropdown) {
            const menu = $(dropdown).find('.dropdown-menu');
            if (menu) {
                const menuLeft = menu.offset().left;
                const menuWidth = menu.outerWidth();
                const documentWidth = body.innerWidth();
                const navbarWidth = $('#navbar .top-container').innerWidth();
                const newWidth = documentWidth - ((documentWidth - navbarWidth) / 2);
                if (menuLeft + menuWidth > newWidth) {
                    menu.offset({'left': newWidth - menuWidth});
                }
            }
        }
    }
    $('.dropdown').on('shown.bs.dropdown', function () {
        dropdown = this;
        calculateAndPositionDropdownMenu();
    });

    let debounce_timeout_calculateAndPositionDropdownMenu;
    function debounced_calculateAndPositionDropdownMenu() {
        console.log('debounced_calculateAndPositionDropdownMenu');
        clearTimeout(debounce_timeout_calculateAndPositionDropdownMenu);
        debounce_timeout_calculateAndPositionDropdownMenu = setTimeout(calculateAndPositionDropdownMenu, 300);
    }
    window.addEventListener('resize', debounced_calculateAndPositionDropdownMenu);

    const scolledNavToggler = $('.scrolled-nav .navbar-toggler');
    const footer = $('#footer');
    if (scolledNavToggler) {
        scolledNavToggler.on('click', function() {
            const navbar = $(this).closest('.navbar');
            if (navbar.hasClass('navbar-shown')) {
                navbar.removeClass('navbar-shown');
                footer.removeClass('nav-shown');
                body.removeClass('navbar-shown');
            } else {
                navbar.addClass('navbar-shown');
                footer.addClass('nav-shown');
                body.addClass('navbar-shown');
            }
        });
    }

    const masonryGrid = $('.masonry-grid');
    if (masonryGrid) {
        masonryGrid.masonry({
            itemSelector: '.grid-item',
        });
    }

    const filterReset = $('.filter-reset');
    if (filterReset) {
        filterReset.on('click', function() {
            const form = $(this).closest('form')[0];
            if (form) {
                form.reset();
            }
        });
    }

    jQuery(document).ready(function($) {
            if (  $('.social-news .post').length ){
            (function loop() {
                $('.social-news .post').each(function() {
                    var $self = $(this);
                    $self.parent().queue(function (n) {
                        $self.fadeIn(1000).delay(5000).fadeOut(1000, n);
                    });
                }).parent().promise().done(loop);
            }());
        }   
    });

})(jQuery);
